module.exports = __webpack_public_path__ + "img/enterprise.b9b441f3.svg";